import {
  PROJECT_GET_WARRANTIES,
  PROJECT_GET_WARRANTIES_LOADING,
  PROJECT_WARRANTY_STATUS_ERROR,
  PROJECT_WARRANTY_CLEAR_SNACKBAR,
  PROJECT_DELETE_WARRANTY_SUCCESS,
  PROJECT_ADD_WARRANTY_SUCCESS,
  PROJECT_ADD_WARRANTY_ERROR,
} from "../constants/types";

import { BULK_UPLOAD_FILE_SUCCESS } from "../constants/documentsConstants";

const initialState = {
  warranties: [],
  loading: true,
  status: "success",
  text: "",
  showSnackbar: false,
  documentsList: [],
};

const warrantyReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECT_WARRANTY_CLEAR_SNACKBAR:
      return {
        ...state,
        showSnackbar: false,
      };
    case PROJECT_GET_WARRANTIES:
      return {
        ...state,
        ...action.payload,
        showSnackbar: false,
      };
    case PROJECT_GET_WARRANTIES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case PROJECT_DELETE_WARRANTY_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case PROJECT_ADD_WARRANTY_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case PROJECT_ADD_WARRANTY_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    case PROJECT_WARRANTY_STATUS_ERROR:
      return {
        ...state,
        // warranties: [],
        loading: false,
        status: action.payload.status,
        text: action.payload.text,
        // showSnackbar: true,
      };
    default:
      return state || {};
  }
};

export default warrantyReducer;
